import { useEffect } from 'react';

const DEFAULT_TITLE = "Crescent Electrical Ltd - Professional Electrical Services | Greater London";
const DEFAULT_DESC = "NICEIC approved electrical contractor in Greater London. EICRs, rewiring, consumer unit upgrades, landlord compliance. Fast response, competitive pricing, certified work.";

export const SEO = ({ title, description, canonical, ogImage }) => {
  useEffect(() => {
    // Safely update document title
    if (title && typeof title === 'string' && title.trim()) {
      document.title = title;
    } else {
      document.title = DEFAULT_TITLE;
    }
    
    // Update meta description
    const metaDesc = description && typeof description === 'string' ? description : DEFAULT_DESC;
    let descTag = document.querySelector('meta[name="description"]');
    if (descTag) {
      descTag.setAttribute('content', metaDesc);
    }
    
    // Update canonical if provided
    if (canonical && typeof canonical === 'string') {
      let canonicalTag = document.querySelector('link[rel="canonical"]');
      if (!canonicalTag) {
        canonicalTag = document.createElement('link');
        canonicalTag.rel = 'canonical';
        document.head.appendChild(canonicalTag);
      }
      canonicalTag.href = canonical;
    }
  }, [title, description, canonical]);
  
  return null;
};
